import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csuserfunc(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
  
return(
      <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free PHP User Defined Function Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php userDefine function tutorial for beginners UserDefine function in Php is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php user defined function example,user defined function in php with example,Php user Defined function for loop,Php exit for loop,exit while loop Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-user-define-function" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">User-defined function in Php</h1>
    <div className="first">
        <a href="/php-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 
    <p className="mt-4 para">The Program can define its function, and a function consist of the following.
    </p>
    <h2 className="mt-4 mh2">There are Many Types of users define a function in Php:
</h2>
<h3 className="mt-4 mh3">1,Function prototype(declaration)<br/>
2,Function definition<br/>
3,Calling function (accessing)<br/>
4,Function argument(parameter)<br/>

</h3>



<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>  {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">function </span>
            <span className="qwerty-5">hello </span>
            <span className="qwerty-2">() </span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-9">echo </span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">hello function </span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-2">"; </span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-9">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-7">This is a function programme </span>
            <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-2">"; </span>
            {"\n"}
            <span className="qwerty-4">hello </span>
            <span className="qwerty-3">();</span>
            <span className="qwerty-10">  &#47;&#47; calling function</span>
            {"\n"}
            <span className="qwerty-6">echo </span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-2">hello is a function </span>
            <span className="qwerty-2">";</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">This is a function program</span>
          {"\n"}
          <span className="qwerty-2">hello function</span>
          {"\n"}
            <span className="qwerty-4">hello is a function</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  



<h2 className="headings">Q- What will be the output of the following function program when a person goes from the USA to stay in the UK and create a plane to travel to India in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-5">USA </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-9"> echo</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> USA</span>
              <span className="qwerty-11"> journey</span>
              <span className="qwerty-9"> \</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-4">";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-2">function </span>
            <span className="qwerty-4">UK </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5"> USA</span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-9"> echo</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-4"> UK</span>
              <span className="qwerty-11"> journey</span>
              <span className="qwerty-9">\</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-4"> ";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-9"> echo</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-10">travel </span>
              <span className="qwerty">start </span>
              <span className="qwerty-9">\</span>
            <span className="qwerty-4">n</span>
            <span className="qwerty-4"> ";</span>
              {"\n"}
              <span className="qwerty-5"> UK</span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-9"> echo</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-6">India</span>
              <span className="qwerty-11"> journey </span>
            <span className="qwerty-4">"</span>
              {"\n"}
            <span className="qwerty-2"> ?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-10">travel </span>
              <span className="qwerty">start </span>
              {"\n"}
              <span className="qwerty-4">USA </span>
              <span className="qwerty-11">journey </span>
              {"\n"}
              <span className="qwerty">UK </span>
              <span className="qwerty-11">journey </span>
              {"\n"}
              <span className="qwerty-6">India</span>
              <span className="qwerty-11"> journey </span>
              {"\n"}</code>{"\n"}</pre>
        </div>   
      </div>

  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/php-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csuserfunc;